/* eslint-disable react/forbid-dom-props */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/macro';
import classNames from 'classnames';
import { Button, Icon } from 'sugar-design';
import * as sdf from '@SDFoundation';

import { downloadByUrl } from '@/utils/common';
import { getI18n } from '@/utils/i18n';

import styles from './index.cm.styl';
import excelSvg from '@/static/images/excel.svg';
import folderSvg from '@/static/images/folder.svg';

const i18n = getI18n();

const ExcelUploader = ({
  refDropZone,
  onDragEnter,
  onDragOver,
  onDragLeave,
  onDrop,
  refExcelFileInput,
  onFileChange,
  downloadExcelFileForCorrection,
  hideExcelDownload,
  showUploadExcelDialog,
  hireMode,
  orgId,
  excelUrl,
  excelErrorMessage,
  excelRows,
  excelSubmitting,
  dropZoneActive,
  excelName,
  percent,
  surplus,
  status,
}) => {
  const downloadTemplate = () => {
    const downloadTemplateUrl = `/api/outer/ats-candidate/candidate/headhunters/downloadExcelTemplate?hireMode=${hireMode}&orgId=${orgId}`;
    downloadByUrl(downloadTemplateUrl);
  };

  return (
    <Fragment>
      <div
        className={classNames({
          [styles.dropzone]: true,
          [styles.active]: dropZoneActive,
        })}
        ref={refDropZone}
        onDragEnter={onDragEnter}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
      >
        <input hidden type="file" accept=".xlsx" ref={refExcelFileInput} onChange={onFileChange} />
        {/* 上传之前 */}
        {!status && (
          <div className={styles.fileContainer}>
            <img src={folderSvg} />
            <div className={styles.desc}>
              <div
                className={classNames(sdf.bodySecondary, styles.descItem)}
              >{i18n.t`1. 请先下载Excel模板文件，一次最多上传500条`}</div>
              <div className={classNames(sdf.bodySecondary, styles.descItem)}>
                <Trans>
                  2. 把文件拖入指定区域或
                  <Button type="text" onClick={showUploadExcelDialog}>
                    添加文件
                  </Button>
                  ，完成上传
                </Trans>
              </div>
            </div>
          </div>
        )}
        {/* 上传中 */}
        {status === 'uploading' && (
          <div className={styles.fileContainer}>
            <img src={excelSvg} />
            <div className={styles.process}>
              <div className={styles.detail}>
                <div className={classNames(sdf.boldBodySecondary, styles.fileName)}>
                  {excelName}
                </div>
                <div className={styles.detailRight}>
                  <div className={classNames(sdf.boldBodySecondary, sdf.b50)}>（{percent}%）</div>
                  <div
                    className={classNames(sdf.boldBodySecondary, styles.surplus)}
                  >{i18n.t`剩余${surplus}秒`}</div>
                </div>
              </div>
              <div className={styles.processLine}>
                <div className={styles.percentLine} style={{ width: `${percent}%` }} />
              </div>
            </div>
            <div className={styles.loading}>
              <Icon name="loading" />
            </div>
          </div>
        )}
        {/* 上传后 */}
        {['success', 'error'].includes(status) && (
          <div className={styles.fileContainer}>
            <img src={excelSvg} />
            <div className={styles.result}>
              <div className={sdf.boldBodySecondary}>{excelName}</div>
              {status === 'success' && (
                <div className={classNames(sdf.g60, sdf.boldCaption)}>
                  {i18n.t`成功解析${excelRows.length}条候选人数据`}
                </div>
              )}
              {excelErrorMessage && (
                <div className={classNames(sdf.r80, sdf.boldCaption)}>{excelErrorMessage}</div>
              )}
            </div>
            <div className={styles.resultOperation}>
              {excelUrl && (
                <Button type="icon" icon="download" onClick={downloadExcelFileForCorrection} />
              )}
              <Button
                className={styles.removeIcon}
                type="icon"
                icon="remove"
                disabled={excelSubmitting}
                onClick={hideExcelDownload}
              />
            </div>
          </div>
        )}
      </div>
      {/* 下载按钮 */}
      <div className={styles.operation}>
        {['success', 'error'].includes(status) ? (
          <Button
            type="text"
            leftIcon="upload"
            onClick={showUploadExcelDialog}
            disabled={status === 'uploading' || excelSubmitting}
          >{i18n.t`重新上传`}</Button>
        ) : (
          <Button
            type="text"
            leftIcon="download"
            disabled={!hireMode}
            onClick={downloadTemplate}
          >{i18n.t`下载模板`}</Button>
        )}
      </div>
    </Fragment>
  );
};

ExcelUploader.protoTypes = {
  /**
   * Drop event
   */
  dropZoneActive: PropTypes.bool,
  refDropZone: PropTypes.func,
  onDragEnter: PropTypes.func,
  onDragOver: PropTypes.func,
  onDragLeave: PropTypes.func,
  onDrop: PropTypes.func,
  /**
   * Upload event
   */
  refExcelFileInput: PropTypes.func,
  onFileChange: PropTypes.func,
  showUploadExcelDialog: PropTypes.func,
  /**
   * During uploading
   */
  percent: PropTypes.number,
  surplus: PropTypes.number,
  excelSubmitting: PropTypes.bool,
  /**
   * After uploaded
   */
  status: PropTypes.string,
  downloadExcelFileForCorrection: PropTypes.func,
  hideExcelDownload: PropTypes.func,
  /**
   * Excel info
   */
  excel: PropTypes.string,
  excelName: PropTypes.string,
  excelErrorMessage: PropTypes.string,
  excelUrl: PropTypes.string,
  excelRows: PropTypes.array,
  /**
   * Download template required info
   */
  hireMode: PropTypes.number,
  orgId: PropTypes.string,
};

export default ExcelUploader;
